export default __webpack_public_path__ + "media/677f71c2c42860b3f07d13867aef162cc3fa01518f6f2ddb7da9765b74221b3d.svg";